import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-collection-grid-processed]', container).each((i, grid_container) => {
    const $grid_container = $(grid_container);
    const $headings = $grid_container.find('[data-rte-collection-grid-headings]');
    const $grid = $grid_container.find('[data-grid]');
    const $product_tiles = $grid.find('[data-product-tile]');

    // weird things happen when you use the same format as shopify...
    const possibly_json = $grid_container.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const {settings} = JSON.parse(json);

    $headings.find('[data-preheading]').addClass('Section__preheading');
    $headings.find('[data-heading]').addClass('Section__heading');
    $headings.find('[data-description]').addClass('Section__description');
    $headings.css({
      display: 'block',
    });

    if (settings.animation !== 'none') {
      $product_tiles.addClass(`AnimateOnLoad Animate--${settings.animation}`);
    }

    $grid.addClass(`CollectionGrid--columns-${settings.columns}`)
      .addClass(`CollectionGrid--mobile-columns-${settings['columns--mobile']}`);

    const section_id = `RteCollectionGrid--${i}`;
    const grid_section = `
      <section
        id="section${section_id}" 
        data-section-id="${section_id}" 
        data-section-type="INF-CollectionGrid" 
        class="Section Section--${settings.width} Section--${settings['width--mobile']} ${settings.section_animation && settings.section_animation !== 'none' ? `Animate Animate--${settings.section_animation}` : ''}"
        style="${settings.use_background ? `background: ${settings.background};` : ''}"
        > 
        <div class="Section__container">
          ${$grid_container.prop('outerHTML')}
        </div>
      </section>

      <style>
        #section${section_id} .Section__container {
          padding-top: ${settings.padding_top}px;
          padding-bottom: ${settings.padding_bottom}px;
        }
        @media only screen and (max-width: 767px) {
          #section${section_id} .Section__container {
            padding-top: ${settings['padding_top--mobile']}px;
            padding-bottom: ${settings['padding_bottom--mobile']}px;
          }      
        }
      </style>
    `;

    $grid_container.html(grid_section);
  });
};